export default {
  filterTypes: ['brand', 'colour', 'price', 'material', 'type'],
  filters: [],
  colours: [],
  search: '',
  loaded: false
}
